<section class="story-section">
  <div class="story-container">
    <div class="story-text">
      <h3 class="Display-family heading-bold-36 Text-10">
        Our Story<br />
        Achievements & Milestones
      </h3>
      <p class="paragraph-regular-16 Text-10">
        150 years of global shipping, logistics and trade. Underpinned by our
        dedication to safety and the markets that we serve
      </p>
    </div>
  </div>
</section>
<section class="carousel-slider">
  <app-multi-card-slider></app-multi-card-slider>
</section>
<section class="celebrating-years">
  <div class="celebrating-inner">
    <h2 class="heading-bold-36 Text-10 Display-family">
      Celebrating 150 years of Connecting Trade Globally
    </h2>
    <div class="video-frame">
      <video controls>
        <source
          src="https://dcasvmrn70pnz.cloudfront.net/assets/swirecnco/swire-150th-years.mp4#t=3"
          type="video/mp4"
        />
        <source
          src="https://dcasvmrn70pnz.cloudfront.net/assets/swirecnco/swire-150th-years.mp4"
          type="video/ogg"
        />
        Your browser does not support the video tag.
      </video>
    </div>
  </div>
</section>
<section class="china-company bg-text-10">
  <div class="china-section">
    <div class="col-50 left-section">
      <div class="china-heading">
        <h3 class="Display-family heading-bold-36 Text-100">
          The China Navigation Company<br />Crest and Name
        </h3>
        <p class="paragraph-regular-16 Text-100">
          CNCo’s crest features the swire family’s motto - Esse Quam Videri -
          which has been used since the 18th century. Translated as ‘To be
          rather than to seem to be’, it means we are what we say we are, we do
          what we say we do. This ethos has underpinned our endeavours, and
          continues to do so today. We have adopted the CNCo crest at the core
          of our anniversary logo. It is a reminder for us to remember our roots
          and take pride in our heritage so that we continue to forge a
          purposeful future.
        </p>
      </div>
    </div>
    <div class="col-50 right-section">
      <div class="img-dragon">
        <img src="../../assets/media/essam-quem.png" />
      </div>
    </div>
  </div>
</section>
<section class="archive-section">
  <div class="archieve-container">
    <h2 class="heading-bold-40 Text-10 Display-family">
      Looking to dive deeper? We have 150 years of history to share!
    </h2>
    <a href="mailto:swirearchives@jsshk.com" class="paragraph-semibold-22"
      >Contact Our Archives Team</a
    >
  </div>
</section>
